import script from "./web-artist-detail.vue?vue&type=script&setup=true&lang=js"
export * from "./web-artist-detail.vue?vue&type=script&setup=true&lang=js"

import "./web-artist-detail.vue?vue&type=style&index=0&id=81d8e7ac&lang=scss"

const __exports__ = script;

export default __exports__